import cn from 'classnames';
import React from 'react';

import ColourSwatchView from './ColourSwatchView';
import { useColourSwatchModel } from './useColourSwatchModel';
import styles from './ColourSwatch.module.scss';

const IMAGE_SIZE_PDP = 32;

export interface ColourSwatchPdpProps {
  colourId: number;
}

/** PDP product page swatch — Figma placement PDP tokens (fixed outer, focus ring, etc.) */
const ColourSwatchPdp: React.FC<ColourSwatchPdpProps> = ({ colourId }) => {
  const model = useColourSwatchModel(colourId);
  if (!model) return null;

  const { colour, ...rest } = model;

  return (
    <ColourSwatchView
      {...rest}
      colour={colour}
      wrapperClassName={cn(styles.wrapper, styles.wrapperPdp)}
      buttonClassName={cn(styles.button, styles.buttonPdp, {
        [styles.buttonSelected]: colour.isSelected,
        [styles.buttonUnavailableForSize]: colour.isDisabled,
        [styles.buttonNoData]: model.isNoData,
      })}
      imageWidth={IMAGE_SIZE_PDP}
      imageHeight={IMAGE_SIZE_PDP}
    />
  );
};

export default ColourSwatchPdp;
